<template>
    <el-dialog :title="userInfoTitle" width="45%" :visible.sync="isVisible" :before-close="closeDialog" v-loading="loading" element-loading-text="请稍等···">
        <el-form :model="userPasswordInfo" :rules="rules" ref="userPasswordInfo" label-width="100px">
            <el-form-item label="当前密码" prop="password">
                <el-col :span="22">
                    <el-input placeholder="请输入当前的密码" type="password" v-model="userPasswordInfo.password" show-password></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-col :span="22">
                    <el-input v-model="userPasswordInfo.newPassword" type="password" show-password placeholder="请输入新的密码"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="确认新密码" prop="newPassword2">
                <el-col :span="22">
                    <el-input v-model="userPasswordInfo.newPassword2" type="password" show-password placeholder="请再次输入新的密码"></el-input>
                </el-col>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog()">取消</el-button>
            <el-button type="primary" @click="handleSubmit()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
  props: ['userPasswordInfo', 'userInfoTitle', 'userInfoOperate'],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.userPasswordInfo.newPassword2 !== '') {
          this.$refs.userPasswordInfo.validateField('newPassword2');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新的密码'));
      } else if (value !== this.userPasswordInfo.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      isVisible: true,
      loading: false,
      rules: {
        password: [{ required: true, message: '请输入当前的密码', trigger: 'blur' }],
        newPassword: [{ required: true, trigger: 'blur', validator: validatePass }],
        newPassword2: [{ required: true, trigger: 'blur', validator: validatePass2 }],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.userPasswordInfo.validate((valid) => {
        if (valid) {
          this.$message.confirmMessage('修改密码成功后需重新登录', () => {
            const editParams = {
              prePassword: this.userPasswordInfo.password,
              preNewPassword: this.userPasswordInfo.newPassword,
            };
            this.userInfoRequest('/console/userManage/updateUserPassword', editParams);
          });
        }
      });
    },
    userInfoRequest(url, params) {
      this.loading = true;
      this.$http.post(url, params).then(() => {
        this.$emit('user-info-success');
      })
      .catch(() => { this.$http.buildErrorHandler(`${url}请求失败！`); })
      .finally(() => {
        this.loading = false;
      });
    },
    closeDialog() {
      this.$emit('close-dialog');
    },
  },
  computed: {
  },
};
</script>



// WEBPACK FOOTER //
// editPwdDialog.vue?cd7d1ec2